<template>
  <div>
    <main-navigation />

    <div class="container py-4">
      <div class="d-flex justify-content-between align-items-center mb-4 header-title">
        
        <div class="">
          <h2 class="fw-bold mb-0 ">My Properties</h2>
          <span>
            {{ totalProperties }} properties · {{ totalUnits }} units · {{ occupiedUnits }} occupied
          </span>
        </div>
        <button class="add-btn" @click="$router.push('/add/house')"> 
          <i class="bi bi-plus"></i>
          Add property
        </button>
        <div v-if="loading" class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm text-primary me-2"></div>
          <small class="text-muted">Loading...</small>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

      <div v-if="!loading && houses.length === 0" class="text-center py-5">
        <h5 >No properties found</h5>
        <router-link to="/add/house" class="btn btn-primary mt-3">
          Add Property
        </router-link>
      </div>

      <div v-if="!loading && houses.length" class="row g-4">
        <div class="col-md-4" v-for="house in houses" :key="house.id">
          <div class="card house-card h-100">
            <div class="card-body d-flex flex-column">

              <div class="d-flex justify-content-between mb-2">
                <div class="card-head ">
                  <h5 class="fw-bold">{{ house.name }}</h5>
                  <span class="badge">
                    <i class="bi bi-door-closed-fill"></i>
                    {{ unitStats(house.id).total }} units
                  </span>
                </div>
                <span class="occupied-stat">{{ unitStats(house.id).percentageOccupied }}% occupied</span>
              </div>
              <!-- test  {{ units }} -->


              <div class="progress mb-3" style="height: 8px;">
                <div
                  class="progress-bar bg-success"
                  :style="{ width: unitStats(house.id).occupiedPct + '%' }"
                />
                <div
                  class="progress-bar bg-warning"
                  :style="{ width: unitStats(house.id).vacantPct + '%' }"
                />
              </div>

              <div class="d-flex gap-2 mb-3">
                <span class="badge2 bg-success">
                  Occupied:
                  <span>{{ unitStats(house.id).occupied }}</span> 
                </span>
                <span class="badge2 bg-warning text-dark">
                  Vacant: 
                  <span>{{ unitStats(house.id).vacant }}</span>
                </span>
              </div>

              <p class="text-muted small flex-grow-1">
                {{ house.description || "No description available" }}
              </p>

              <div class="d-flex gap-4 justify-content-between mt-auto">
                <router-link
                  :to="`/house/${house.id}/units`"
                  class="unit btn btn-primary btn-sm"
                >
                  View Units 
                </router-link>

                <button
                  class="btn btn-outline-secondary btn-sm"
                  @click="downloadUnitsCsv(house)"
                >
                  <i class="bi bi-download"></i>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <router-link
      to="/add/house"
      class="btn btn-primary position-fixed bottom-0 end-0 m-4"
    >
      Add Property
    </router-link>
  </div>
</template>
<script>
import { apiFetch } from '../../services/api';

export default {
  name: "HousesList",

  data() {
    return {
      houses: [],
      units: [],
      loading: true,
      error: "",

    };
  },

  mounted() {
    this.fetchHouses();
    this.fetchUnits();
  },

  computed:{
    totalUnits(){
      return this.units.length; 
    },

    occupiedUnits(){
      return this.units.filter(unit => unit.status === 'occupied').length;
    },

    totalProperties(){
      return this.houses.length;
    }
  },
  methods: {
    async fetchHouses() {
      try {
        const data = await apiFetch('/houses');
        this.houses = Array.isArray(data) ? data : data.data || [];
      } catch (e) {
        this.error = "Failed to load houses";
      } finally {
        this.loading = false;
      }
    },

  async fetchUnits() {
  try {
    const data = await apiFetch("/units"); // drop manual auth header if apiFetch handles it internally

    const rawUnits = Array.isArray(data)
      ? data
      : Array.isArray(data.data)
        ? data.data
        : [];

    this.units = rawUnits.map(u => {
      const occupied = !!u.tenant_id;
      return {
        ...u,
        status: occupied ? "occupied" : "vacant",
        tenant_name: u.tenant_name || "",
        tenant_phone: u.Tenant?.tenant_phone || ""
      };
    });
  } catch (err) {
    console.error("Failed to load units:", err);
  }
  },



    // ✅ SAFE & ACCURATE STATS
    unitStats(houseId) {
      const houseUnits = this.units.filter(u => u.house_id === houseId);

      let occupied = 0;
      let vacant = 0;

      houseUnits.forEach(u => {
        const status = (u.status || "vacant").toLowerCase();
        if (status === "occupied") occupied++;
        else vacant++;
      });

      const total = houseUnits.length || 1;

      const percentageOccupied = Math.round((occupied/total) * 100);


      return {
        total: houseUnits.length,
        occupied,
        vacant,
        occupiedPct: (occupied / total) * 100,
        vacantPct: (vacant / total) * 100,
        percentageOccupied
      };
    },

    

    //NEW DOWNLOAD CSV METHOD
    async downloadUnitsCsv(house) {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login again");
      return;
    }

    const res = await fetch(
      `https://golang.roberms.com/api/units/house/${house.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) {
      throw new Error(`Request failed with status ${res.status}`);
    }

    const response = await res.json();

    console.log("CSV UNITS RESPONSE:", response);

    // ✅ IMPORTANT FIX
    const units = Array.isArray(response.data) ? response.data : [];

    if (units.length === 0) {
      alert("No units found for this house");
      return;
    }

    const headers = [
      "Unit",
      "Rent",
      "Deposit",
      "Status",
      "Tenant Name",
      "Tenant Phone"
    ];

    const rows = units.map(u => {
      const status =
        u.status === "occupied" || u.tenant_id
          ? "occupied"
          : "vacant";

   const tenantName =
  u.Tenant && u.Tenant.tenant_name ? u.Tenant.tenant_name : "";

const tenantPhone =
  u.Tenant && u.Tenant.tenant_phone ? u.Tenant.tenant_phone : "";

      return [
        u.unit_number || "",
        u.rent_amount || 0,
        u.deposit_amount || 0,
        status,
        tenantName, 
        tenantPhone
      

        // u.Tenant?.tenant_name || "",
        // u.Tenant?.tenant_phone || ""
      ];
    });

    const csvContent =
      headers.join(",") + "\n" +
      rows.map(r => r.map(v => `"${v}"`).join(",")).join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;"
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${house.name.replace(/\s+/g, "_")}_units.csv`;
    link.click();

    URL.revokeObjectURL(url);

  } catch (err) {
    console.error("CSV download error:", err);
    alert("Failed to download CSV");
  }
}



    // ✅ BULLETPROOF CSV DOWNLOAD
// downloadUnitsCsv(house) {
//   if (!Array.isArray(this.units)) return;

//   const houseUnits = this.units.filter(
//     u => u.house_id === house.id
//   );

//   if (!houseUnits.length) {
//     alert("No units found for this house");
//     return;
//   }

//   const headers = [
//     "Unit",
//     "Rent",
//     "Deposit",
//     "Status",
//     "Tenant Name",
//     "Tenant Phone"
//   ];

//   const rows = houseUnits.map(u => {
//     const occupied = !!u.tenant_id;

//     return [
//       u.unit_number || "",
//       u.rent_amount ?? "",
//       u.deposit_amount ?? "",
//       occupied ? "occupied" : "vacant",
//       occupied ? (u.tenant_name || "") : "",
//       occupied ? (u.tenant_phone || "") : ""
//     ];
//   });

//   const csvContent =
//     headers.join(",") + "\n" +
//     rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(","))
//         .join("\n");

//   const blob = new Blob([csvContent], {
//     type: "text/csv;charset=utf-8;"
//   });

//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = `${house.name.replace(/\s+/g, "_")}_units.csv`;
//   link.click();

//   URL.revokeObjectURL(url);
// },




  }
};
</script>

<style scoped>

.container { max-width: var(--dash-maxw); }

.header-title h2 {
  font-size: var(--dash-fs-h1);
  letter-spacing: -0.02em;
  color: var(--dash-ink);
}

.header-title span {
  font-size: var(--dash-fs-xs);
  color: var(--dash-muted);
  font-variant-numeric: tabular-nums;
}

.house-card {
  transition: box-shadow var(--dash-t), transform var(--dash-t), border-color var(--dash-t);
  border-radius: var(--dash-radius);
  background: var(--dash-surface);
  border: 1px solid var(--dash-line);
  box-shadow: var(--dash-shadow-xs);
}

.house-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--dash-shadow);
  border-color: var(--dash-primary-line);
}

.house-card h5 {
  font-size: var(--dash-fs-body);
  color: var(--dash-ink);
  margin-bottom: 4px;
}

.header-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  padding: 11px 20px;
  border-radius: var(--dash-pill);
  box-shadow: var(--dash-shadow-primary);
  width: auto;
  min-height: 42px;
  white-space: nowrap;
  cursor: pointer;
  background: var(--dash-primary);
  color: #ffffff;
  font-family: inherit;
  font-size: var(--dash-fs-sm);
  font-weight: 600;
  transition: background var(--dash-t), transform var(--dash-t), box-shadow var(--dash-t);
}

.add-btn:hover {
  background: var(--dash-primary-hover);
  transform: translateY(-1px);
}

.add-btn:active {
  transform: scale(0.97);
}

.add-btn:focus-visible {
  outline: 2px solid var(--dash-primary);
  outline-offset: 2px;
}

@media (max-width: 576px) {
  .add-btn {
    width: 100%;
    padding: 12px 16px;
  }
}


.badge{
  color: var(--dash-muted);
  background: var(--dash-bg-alt);
  font-size: var(--dash-fs-micro);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

/* Occupied / vacant counters. These were sized in vw/vh, which made them
   overflow their own card on every screen — now they just share the row. */
.badge2{
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 7px 12px;
  border-radius: var(--dash-radius-xs);
  font-size: var(--dash-fs-micro);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.badge2.bg-success {
  background: var(--dash-success-soft) !important;
  color: var(--dash-success-ink);
}

.badge2.bg-warning {
  background: var(--dash-warning-soft) !important;
  color: var(--dash-warning-ink) !important;
}

.occupied-stat{
  background-color: var(--dash-primary-soft);
  padding: 4px 12px;
  height: max-content;
  color: var(--dash-primary-ink);
  border-radius: var(--dash-pill);
  font-size: var(--dash-fs-micro);
  font-weight: 650;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.description {
  font-size: 14px;
  color: var(--dash-muted);
  line-height: 1.6;
}

.progress {
  border-radius: var(--dash-pill);
  overflow: hidden;
  height: 8px;
  background: var(--dash-bg-alt);
}

/* "View units" fills the remaining row width instead of a vw guess */
.unit{
  flex: 1 1 auto;
  text-align: center;
}


.progress-bar {
  height: 100%;
  transition: width 0.3s ease;
}
</style>
